export default __webpack_public_path__ + "static/media/add-friend.1ce0cf40.png";